import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import leftBlock from './assets/leftBlock.svg';
import rightBlock from './assets/rightBlock.svg';

import useStyles from './useStyles';

export const WelcomeRetrialPopup = ({ open, onClose, onSubmit }) => {
  const styles = useStyles();

  return (
    <Dialog
      classes={{ root: styles.root, paper: styles.paper }}
      open={open}
      onClose={onClose}
    >
      <DialogContent className={styles.dialogContent}>
        <img
          className={styles.leftBlockImg}
          src={leftBlock}
          alt=""
        />
        <img
          src={rightBlock}
          alt=""
        />
        <Button
          className={styles.submitButton}
          onClick={onSubmit}
          color="primary"
          variant="contained"
        >
          See it in action
        </Button>
      </DialogContent>
    </Dialog>
  );
};

WelcomeRetrialPopup.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

WelcomeRetrialPopup.defaultProps = {
  className: null,
};
